import { createUseStyles } from 'react-jss'

export const style = {
  topControls: {
    width: 'auto',
    height: '50px',
    display: 'flex',

    margin: '0',
    lineHeight: '1',
    alignItems: 'center',

    overflowX: 'hidden',
    overflowY: 'hidden',
    whiteSpace: 'nowrap'
  },
  topControlsLabel: {
    fontSize: '16px',
    fontWeight: 'normal',
    marginRight: '4px'
  },
  topControlsSelect: {
    height: '24px',
    marginRight: '4px',
    fontSize: '14px',
    backgroundColor: 'white',
    border: '1px solid #cccccc',
    borderRadius: '4px'
  },
  legendPane: {
    overflowX: 'auto',
    display: 'flex'
  },
  legendCell: {
    width: '80px',
    display: 'flex',
    flexDirection: 'column',
    textOverflow: 'ellipsis',
    textAlign: 'center'
  },
  legendBand: {
    margin: '0px auto 2px auto',
    width: '60px',
    height: '8px'
  },
  legendLabel: {
    margin: '2px 3px',
    color: 'black',
    fontSize: '10px',
    whiteSpace: 'normal'
  }
}

export const useStyles = createUseStyles(style)
